import React, { useState } from 'react'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import useEventFormsValidations from '../../../../hooks/useEventFormsValidations'
import parseEventFormSubmit from '../../../../utils/helpers/eventHelpers/parseEventFormSubmit'
import parseGameEventFormSubmit from '../../../../utils/helpers/eventHelpers/parseGameEventFormSubmit'
import getGameEventInitialValues from '../../../../utils/helpers/eventHelpers/getGameEventInitialValues'
import courtType from '../../../../types/courtType'
import mutationType from '../../../../types/mutationType'
import teamType from '../../../../types/teamType'
import eventVariantType from '../../../../types/events/eventVariantType'
import calendarDateClickType from '../../../../types/calendarDateClickType'
import eventType from '../../../../types/events/eventType'
import eventRawType from '../../../../types/events/eventRawType'
import { useTeamCalendarContext } from '../../../../context/useTeamCalendarContext'
import localStorageIds from '../../../../utils/constants/localStorageIds'
import useGetLocalStorage from '../../../../hooks/useGetLocalStorage'
import GameEventFormFields from './GameEventFormFields/GameEventFormFields'
import { canUseOrgYoutube } from '../../../../utils/helpers/youtubeLink'
import USER_PERMISSIONS from '../../../../utils/constants/userPermissions'
import hasPermission from '../../../../utils/helpers/hasPermission'

const BasketGameEventForm = (props) => {
  const {
    clickedEventId,
    createEvent,
    updateEvent,
    event,
    selectedEventType,
    setFormDirty,
    currentTeam,
    teams,
    dateClick,
    eventsRaw,
    setEvents,
    courts,
  } = props

  const { gamedayId } = useTeamCalendarContext()
  const [mediaIsUploading, setMediaIsUploading] = useState(false)
  const [isUploadingModalOpen, setIsUploadingModalOpen] = useState(false)

  const localStorageValue = useGetLocalStorage()
  const {
    [localStorageIds.SELECTED_ORG]: selectedOrg,
    [localStorageIds.SELECTED_SEASON]: selectedSeason,
  } = localStorageValue || {}
  const { type: orgType } = selectedOrg || {}

  const { broadcast, ytBroadcastDetails } = event || {}
  const { id, streamDestination, state } = broadcast || {}
  const { broadcastId } = ytBroadcastDetails || {}

  const statsMode = selectedSeason?.statsMode
  const hasSetYoutube = canUseOrgYoutube(selectedOrg, broadcastId)
  const useOrgYoutube = broadcastId || !streamDestination
  const allowOrgYoutube =
    hasSetYoutube &&
    hasPermission(USER_PERMISSIONS.UPDATE_EVENT)

  const { createLivestreamEventValidations, editLivestreamEventValidations } =
    useEventFormsValidations('game', id, hasSetYoutube, useOrgYoutube, event)

  const onGameSubmit = (data) => {
    if (event) {
      updateEvent.mutate({
        formData: parseEventFormSubmit(
          parseGameEventFormSubmit(data, courts, selectedEventType, mediaIsUploading),
        ),
        eventId: clickedEventId,
        eventType: selectedEventType,
      })
    } else {
      const payload = {
        formData: parseEventFormSubmit(
          parseGameEventFormSubmit(data, courts, selectedEventType, mediaIsUploading),
        ),
        eventType: selectedEventType,
      }

      if (gamedayId) {
        payload.formData.GamedayId = gamedayId
      }

      createEvent.mutate(payload)
    }
  }

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validate={clickedEventId ? editLivestreamEventValidations : createLivestreamEventValidations}
      initialValues={getGameEventInitialValues({
        event,
        dateClick,
        currentTeam,
        teams,
        allowOrgYoutube,
        useOrgYoutube,
        orgType,
        courts,
        orgSharedRevenue: selectedOrg?.sharedRevenue,
      })}
      onSubmit={(data) => {
        if (mediaIsUploading) {
          setIsUploadingModalOpen(true)
          return
        }

        onGameSubmit(data)
      }}
    >
      <GameEventFormFields
        event={event}
        state={state}
        orgType={orgType}
        courts={courts}
        teams={teams}
        currentTeam={currentTeam}
        selectedEventType={selectedEventType}
        clickedEventId={clickedEventId}
        eventsRaw={eventsRaw}
        setEvents={setEvents}
        setFormDirty={setFormDirty}
        allowOrgYoutube={allowOrgYoutube}
        broadcastId={broadcastId ?? null}
        mediaIsUploading={mediaIsUploading}
        setMediaIsUploading={setMediaIsUploading}
        isUploadingModalOpen={isUploadingModalOpen}
        setIsUploadingModalOpen={setIsUploadingModalOpen}
        statsMode={statsMode}
        onGameSubmit={onGameSubmit}
      />
    </Formik>
  )
}

BasketGameEventForm.propTypes = {
  clickedEventId: PropTypes.string,
  createEvent: mutationType,
  updateEvent: mutationType,
  event: eventType,
  selectedEventType: eventVariantType,
  setFormDirty: PropTypes.func,
  currentTeam: teamType,
  teams: PropTypes.arrayOf(teamType),
  dateClick: calendarDateClickType,
  eventsRaw: PropTypes.arrayOf(eventRawType),
  setEvents: PropTypes.func,
  courts: PropTypes.arrayOf(courtType),
}

export default BasketGameEventForm
